import ActionStatus from '@sunbit-dev/common/enums/ActionStatus';
import CommonThunk from '../models/CommonThunk';
import sunbitApi from '../services/sunbitApi';
import { replace } from 'connected-react-router';
import URLS from '../constants/urls';
export enum ApprovalTermsActions {
  submitAcceptOffer = 'submitAcceptOffer',
}

const submitAcceptOfferPending = () => ({
  type: ApprovalTermsActions.submitAcceptOffer,
  status: ActionStatus.Pending,
});

const submitAcceptOfferFailure = (error: any) => ({
  type: ApprovalTermsActions.submitAcceptOffer,
  status: ActionStatus.Failure,
  error,
});

const submitAcceptOfferSuccess = () => ({
  type: ApprovalTermsActions.submitAcceptOffer,
  status: ActionStatus.Success,
});

export const submitAcceptOffer = (): CommonThunk => {
  return async (dispatch) => {
    dispatch(submitAcceptOfferPending());
    try {
      await sunbitApi.acceptOffer();
      dispatch(submitAcceptOfferSuccess());
      dispatch(replace(URLS.applicationPaymentDetails));
    } catch (error) {
      dispatch(submitAcceptOfferFailure(error));
    }
  };
};
